// components
import Image from 'next/image';
import YoutubeVideo from '@/components/utilities/YoutubeVideo';
import { Icon } from '@/components/ui/icon';
import { Button } from '@/components/ui/button';
import Link from '@/components/utilities/SmartLink';

// utilities
import VisibleLoading from '@/components/utilities/VisibleLoading';
import { getImagePath } from '@/utils/images';

const WebinarsBlock = ({ webinars, showVideoLabel }) => {
  const featured = (webinars || []).slice(0, 3);
  const rest = (webinars || []).slice(3);

  return (
    <div className="mx-auto my-10 w-[90vw] xl:w-(--container-width)">
      {featured.length > 0 && (
        <div className="-mx-3 mb-16 flex flex-wrap gap-y-6 xl:mb-32">
          {featured.map((item, index) => (
            <VisibleLoading key={item.id} delay={(index + 1) * 200}>
              {({ ref, className }) => (
                <div ref={ref} className={`basis-full px-3 xl:basis-1/3 ${className || ''}`.trim()}>
                  <div className="flex h-full flex-col gap-4 rounded-2xl bg-white p-4 shadow-2xl/15">
                    <div className="h-[250px]">
                      <YoutubeVideo
                        videoId={item.video.videoId}
                        thumbnail={
                          item.video.image ? (
                            <Image
                              src={getImagePath(item.video.image)}
                              alt={item.name}
                              fill={true}
                              className="object-cover"
                            />
                          ) : null
                        }
                      />
                    </div>

                    <div className="flex-1">
                      {item.date && <div className="txt-md">{new Date(item.date).toLocaleDateString('cs-CZ')}</div>}
                      <h6 className="mb-3 line-clamp-2 min-h-[56px]">{item.name}</h6>

                      <div className="txt-lg text-grey-700 line-clamp-4">{item.description}</div>
                    </div>

                    <div className="">
                      <Button asChild={true} className="basis-full xl:basis-auto">
                        <Link href={`https://youtu.be/${item.video.videoId}`} target="_blank" rel="noopener noreferrer">
                          <Icon type="play" /> {showVideoLabel}
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </VisibleLoading>
          ))}
        </div>
      )}

      {rest.length > 0 && (
        <div className="-mx-3 flex flex-wrap gap-y-6">
          {rest.map((item, index) => (
            <VisibleLoading key={item.id} delay={((index % 3) + 1) * 200}>
              {({ ref, className }) => (
                <div ref={ref} key={item.id} className={`basis-full px-3 xl:basis-1/3 ${className || ''}`.trim()}>
                  <Link
                    href={`https://youtu.be/${item.video.videoId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group"
                  >
                    <div className="group-hover:bg-brand-100 bg-brand-50 flex h-full gap-3 rounded-lg p-5 transition-colors">
                      <div className="bg-brand-400 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-white">
                        <Icon type="play" width={17} height={17} />
                      </div>
                      <div className="flex flex-1 flex-col">
                        <div className="txt-lg font-medium">{item.name}</div>
                        {item.date && (
                          <div className="txt-md mb-1">{new Date(item.date).toLocaleDateString('cs-CZ')}</div>
                        )}
                        <div className="txt-md line-clamp-2 text-gray-700">{item.description}</div>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </VisibleLoading>
          ))}
        </div>
      )}
    </div>
  );
};
export default WebinarsBlock;
